import React from "react";
import { BsFillGridFill,BsGrid, BsFillPersonFill,BsPerson, BsCart2,BsCartFill, BsHeart, BsHeartFill } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import symbolWhite from "../images/symbolWhite.svg";
import { useTranslation } from 'react-i18next';

const BottomNav = () => {

  const locationNow = useLocation();
  const { t } = useTranslation();

  if (
    locationNow.pathname === "/" ||
    locationNow.pathname === "/Cart" ||
    locationNow.pathname === "/MyPage" ||
    locationNow.pathname === "/Pick" ||
    locationNow.pathname === "/Category"
  ) {
    return (
        <div className="bottomNav">
            <nav className="navWrapper">
                <Link to="/" className={locationNow.pathname === "/" ? "navLink active": "navLink"}>
                    <img src={symbolWhite}/>
                    <p className="txt">{t(`Message.nav_home`)}</p>
                </Link>
                <Link to="/Category" className={locationNow.pathname === "/Category" ? "navLink active" : "navLink"}>
                    {locationNow.pathname === "/Category" ? <BsFillGridFill/>:<BsGrid/>}
                    <p className="txt">{t(`Message.nav_category`)}</p>
                </Link>
                <Link to="/Pick" className={locationNow.pathname === "/Pick" ? "navLink active": "navLink"}>
                    {locationNow.pathname === "/Pick" ? <BsHeartFill/>:<BsHeart/>}
                    <p className="txt">{t(`Message.nav_pick`)}</p>
                </Link>
                <Link to="/Cart" className={locationNow.pathname === "/Cart" ? "navLink active" : "navLink"}>
                    {locationNow.pathname === "/Cart" ? <BsCartFill />:<BsCart2/>}
                    <p className="txt">{t(`Message.nav_cart`)}</p>
                </Link>
                <Link to="/MyPage" className={locationNow.pathname === "/MyPage" ? "navLink active" : "navLink"}>
                    {locationNow.pathname === "/MyPage" ? <BsFillPersonFill/>:<BsPerson/>}
                    <p className="txt">{t(`Message.nav_mypage`)}</p>
                </Link>
            </nav>
        </div>
    );
  } else {
    return null;
  }
};

export default BottomNav;